/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 scene.gltf --transform
Author: Kanna-Nakajima (https://sketchfab.com/Kanna-nakajima)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/tiny-low-poly-room-d52290030bb14ab3b14b07190859a487
Title: Tiny low-poly room
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import {
  Text,
  Html,
  ContactShadows,
  PresentationControls,
  Float,
  Environment,
  OrbitControls,
  Box,
} from "@react-three/drei";

export default function Room(props) {
  const { nodes, materials } = useGLTF("/models/room/scene-transformed.glb");
  return (
    <Canvas camera={(0, 10, 0)} style={{ width: "500px", height: "800px" }}>
      <OrbitControls />
      <ambientLight intensity={1} />
      <group {...props} dispose={null}>
        <group position={(0, 20, 0)} scale={0.0005}>
          <group
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0.08]}
            scale={1337.38}
          >
            <mesh
              geometry={nodes.Cube007_Material017_0.geometry}
              material={materials["Material.017"]}
            />
            <mesh
              geometry={nodes.Cube007_Material002_0.geometry}
              material={materials["Material.002"]}
            />
          </group>
          <mesh
            geometry={nodes.Cube_Material015_0.geometry}
            material={materials["Material.015"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Plane_Material003_0.geometry}
            material={materials["Material.003"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cylinder_Material007_0.geometry}
            material={materials["Material.007"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cylinder010_Material023_0.geometry}
            material={materials["Material.023"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 2.71]}
            scale={2157.95}
          />
          <mesh
            geometry={nodes.Cylinder012_Material009_0.geometry}
            material={materials["Material.009"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 2.71]}
            scale={2157.95}
          />
          <mesh
            geometry={nodes.Cylinder003_Material016_0.geometry}
            material={materials["Material.016"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={717.86}
          />
          <mesh
            geometry={nodes.Plane001_Material002_0.geometry}
            material={materials["Material.002"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={254.15}
          />
          <mesh
            geometry={nodes.Cube004_Material023_0.geometry}
            material={materials["Material.023"]}
            position={[-1972.11, 1873.19, -1772.03]}
            rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
            scale={254.15}
          />
          <mesh
            geometry={nodes.Cube001_Material004_0.geometry}
            material={materials["Material.004"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube002_Material002_0.geometry}
            material={materials["Material.002"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube003_Material_0.geometry}
            material={materials.Material}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube005_Material015_0.geometry}
            material={materials["Material.015"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube006_Material005_0.geometry}
            material={materials["Material.005"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube008_Material006_0.geometry}
            material={materials["Material.006"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cylinder001_Material008_0.geometry}
            material={materials["Material.008"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube009_Material020_0.geometry}
            material={materials["Material.020"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube010_Material010_0.geometry}
            material={materials["Material.010"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube011_Material012_0.geometry}
            material={materials["Material.012"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube012_Material003_0.geometry}
            material={materials["Material.003"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube013_Material014_0.geometry}
            material={materials["Material.014"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube014_Material013_0.geometry}
            material={materials["Material.013"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cylinder002_Material019_0.geometry}
            material={materials["Material.019"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={717.86}
          />
          <mesh
            geometry={nodes.Cylinder004_Material018_0.geometry}
            material={materials["Material.018"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={717.86}
          />
          <mesh
            geometry={nodes.Cube015_Material011_0.geometry}
            material={materials["Material.011"]}
            position={[-843.21, 134.2, -757.66]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1870.27}
          />
          <mesh
            geometry={nodes.Cube016_Material004_0.geometry}
            material={materials["Material.004"]}
            position={[-1954.18, 1873.19, -1758.59]}
            rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
            scale={254.15}
          />
        </group>
      </group>
    </Canvas>
  );
}

useGLTF.preload("/models/room/scene-transformed.glb");
